// Shared lead-table display constants so the /leads inbox and /leads/search
// results tables render the same text for the same state (surfaces that must
// agree).

// For an owner-occupied row the single org is shown in the Tenant column (it's
// the occupier), and the Landlord column carries this literal instead of
// repeating the same name. Used by both lead tables.
export const OWNER_OCCUPIED_LANDLORD_LABEL = "Owner occupied";
